import storage from 'redux-persist/lib/storage';
import { __DEV__ } from './constants';
import { staticUrls, envOptions, appInfo } from './envConfig';

// If not a production build, allow dynamic config of environments via window object
const isDev = (appInfo.env !== 'production' && appInfo.env !== 'demo');
const hasOverride = isDev && window.APP_ENV;

export const APP_ENV = hasOverride ? window.APP_ENV : appInfo.env;
export const URLS = hasOverride ? window.URLS : staticUrls;
export const ENV_OPTIONS = hasOverride ? window.ENV_OPTIONS : envOptions;

// Grab current environment from build files to show in dev tools
if (isDev) {
	window.APP_ENV = hasOverride ? window.APP_ENV : appInfo.env;
	window.URLS = URLS;
}

export const STRIPE_KEY = envOptions.stripePublishableKey;
export const PLAID_KEY = envOptions.plaidPublicKey;
export const GA_KEY = envOptions.analyticsKey;
export const { useAnalytics, userFlowContents } = envOptions;

export const app = {
	displayName : 'RollKall | Client Portal',
};

export const api = {
	url : URLS.apiUrl,
};

export const ApplicationVersion = appInfo.version;

export const debugSettings = {
	inspectorLogging : __DEV__,
	useReduxDevTools : __DEV__,
};

export const reduxPersist = {
	storage,
	key       : 'v1',
	blacklist : ['app'],
};

export const settingsMenuSections = [
	{
		id : 'personal', title : 'Personal Settings', icon : 'fa fa-cog', staffOnly : false,
	},
	{
		id : 'profile', title : 'Profile Settings', icon : 'rkfm rkfm-person', staffOnly : false,
	},
	{
		id : 'password', title : 'Change Password', icon : 'rkfm rkfm-lock', staffOnly : false,
	},
	{
		id : 'bio', title : 'Company Bio', icon : 'fa fa-building', staffOnly : true,
	},
	{
		id : 'payment', title : 'Payment Methods', icon : 'rkfm rkfm-stats', staffOnly : false,
	},
	{
		id : 'notification', title : 'Notification Settings', icon : 'fa fa-bell', staffOnly : false,
	},
	{
		id : 'tax-exempt', title : 'Tax Exemption', icon : 'rkf rkf-receipt-cross', staffOnly : true,
	},
];

export const reportTypes = [
	{
		value     : 0,
		label     : 'Invoice History Report',
		selectors : [
			'coordinator',
			'officer',
			'location',
			'startDate',
			'endDate',
		],
	},
	{
		value     : 1,
		label     : 'Payment History Report',
		selectors : [
			'coordinator',
			'officer',
			'location',
			'startDate',
			'endDate',
		],
	},
	{
		value     : 2,
		label     : 'Transaction History Report',
		selectors : [
			'startDate',
			'endDate',
		],
	},
	{
		value     : 3,
		label     : 'Officer Overview Report',
		selectors : [
			'officer',
			'startDate',
			'endDate',
		],
	},
	{
		value     : 4,
		label     : 'Client Overview Report',
		selectors : [
			'startDate',
			'endDate',
		],
	},
	{
		value     : 5,
		label     : 'Location Overview Report',
		selectors : [
			'coordinator',
			'location',
			'startDate',
			'endDate',
		],
	},
];

export default {
	app,
	api,
	debugSettings,
	reduxPersist,
	ApplicationVersion,
	settingsMenuSections,
	reportTypes,
	APP_ENV,
	STRIPE_KEY,
	PLAID_KEY,
	GA_KEY,
	useAnalytics,
	userFlowContents,
	ENV_OPTIONS,
};
